// Qué ruta interna abrir cuando el sistema levanta la app con una URL del sitio.
//
// Hoy el único caso es la vuelta desde Mercado Pago: quien paga desde el celular
// arranca en el navegador —la app no linkea la compra, y eso es lo que la
// mantiene dentro de la regla 3.1.1 de Apple—, y sin deep link el recorrido
// terminaba ahí, con el plan pago y la app sin enterarse.
//
// La URL que entrega el sistema es la pública (`https://app.crecientefertil.com.ar/...`)
// y adentro del WebView las rutas son locales, así que lo único que sirve es el
// camino y el querystring.

/**
 * @param {string} url la URL con la que el sistema abrió la app
 * @returns {string|null} la ruta interna a la que navegar, o `null` si no hay
 *                        ninguna que corresponda
 */
export function rutaDeDeepLink(url) {
    let entrante;
    try {
        entrante = new URL(url);
    } catch {
        return null; // no era una URL
    }

    const destino = entrante.pathname + entrante.search;

    // Sólo `/pagos`, que es lo único que el manifest (y los entitlements de iOS)
    // reclaman. Un link a otra cosa se ignora en vez de mandar la app a una ruta
    // que quizá adentro ni existe.
    if (!destino.startsWith("/pagos")) return null;

    return destino;
}
